import { useState, useCallback, useRef } from "react";
import { initStorageNamespace } from "../StorageHandler";
export { initStorageNamespace };
const useHandler = (namespace, version, options) => {
    const handlerRef = useRef();
    let curHandler = handlerRef.current;
    if (!curHandler ||
        curHandler.namespace !== namespace ||
        curHandler.version !== version) {
        curHandler = (handlerRef.current = initStorageNamespace(namespace, version, options));
    }
    if (!curHandler.cacheValidated)
        curHandler.checkCache();
    return curHandler;
};
export const useLocalStorage = (namespace = "", version = "", options) => {
    const handlerInstance = useHandler(namespace, version, options);
    const useStorageKey = useCallback((key, defaultValue, validate) => {
        if (typeof (key) !== "string" || key === "")
            return console.error("useLocalStorage hook called without a proper key value");
        if (typeof defaultValue === "undefined") {
            throw new Error("Trying to set undefined value to state of item");
        }
        const keyHandler = handlerInstance.getKeyHandler(key, defaultValue, validate || (() => true));
        const [get, set] = useState(() => keyHandler.get());
        const setValue = useCallback((x) => {
            set((curState) => {
                const valueToStore = x instanceof Function ? x(curState) : x;
                try {
                    keyHandler.set(valueToStore);
                }
                catch (e) {
                    if (e.code === "CACHE_INVAL") {
                        return curState;
                    }
                    throw e;
                }
                return valueToStore;
            });
        }, [keyHandler]);
        return [get, setValue, key];
    }, [handlerInstance]);
    const useStorageListener = useCallback((signal, handler) => {
        const signalHandler = useRef();
        if (typeof window === "undefined")
            return;
        const curHandler = signalHandler.current;
        if (curHandler !== handler) {
            signalHandler.current = handler;
            if (curHandler)
                handlerInstance.off(signal, handler);
            handlerInstance.on(signal, handler);
        }
    }, [handlerInstance]);
    return { useStorageKey, useStorageListener, storageHandler: handlerInstance };
};
//# sourceMappingURL=useLocalStorage.js.map